<nz-modal
  nzWrapClassName=""
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="onEmitClose()"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}">
  <ng-template #modalTitle>
  </ng-template>

  <ng-template #modalContent>
    <div class="d-flex justify-content-center align-items-center flex-column">
      <img loading="lazy" src="./../../../assets/images/wait-2.jpg" alt="" style="height: 220px;">
      <p class="text-info mt-xlg text-center">
        <i nz-icon nzType="warning" nzTheme="outline" class="mr-xxs"></i>
        ¡Ups! Lo sentimos pero por ahora no puedes ingresar a la plataforma, por favor comunicate con tu clínica para obtener más información.
      </p>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="container-footer-modal d-flex justify-content-center" @fadeInAnimation>
      <button
        (click)="onEmitClose()"
        nz-button nzType="primary">
        <i nz-icon nzType="check-circle" nzTheme="outline"></i>
        ACEPTAR Y CERRAR</button>
    </div>
  </ng-template>
</nz-modal>
